import { createBorder as a, createColorVariable as r, createOutline as o } from "./highrise530.mjs";
function b(e) {
  let s = {
    color: r(e, 600),
    border: a(e, 600),
    rippleColor: r(e, 600),
    textColor: "var(--base-white)",
    // Hover
    colorHover: r(e, 800),
    borderHover: a(e, 800),
    textColorHover: "var(--base-white)",
    // Focus
    colorFocus: r(e, 800),
    outlineFocus: o(e, 100),
    borderFocus: a(e, 800),
    textColorFocus: "var(--base-white)",
    // Pressed
    colorPressed: r(e, 900),
    borderPressed: a(e, 900),
    textColorPressed: "var(--base-white)",
    // Disabled
    colorDisabled: r(e, 200),
    borderDisabled: a(e, 200),
    textColorDisabled: "var(--base-white)"
  };
  return e !== "primary" && (s = {
    ...s,
    colorHover: r(e, 700),
    borderHover: a(e, 700),
    colorFocus: r(e, 700),
    borderFocus: a(e, 700)
  }), s;
}
export {
  b as createPrimaryTheme
};
